<template lang="pug">
  el-form.loginform(:model="loginForm" :rules="rules" ref="form")
    el-form-item(label="您的账号" prop="account")
      el-input.bottom-line-input(v-model="loginForm.account" placeholder="请输入账号/邮箱/电话号码")
    el-form-item(label="您的密码" prop="password")
      el-input.bottom-line-input(v-model="loginForm.password" type="password" show-password placeholder="请输入密码")
    div.errMsg(v-show="isError") 账号或密码错误, 请检查
    el-checkbox(v-model="isAutoLogin" ) 自动登录
</template>

<script>
  import {mapActions, mapMutations, mapState} from "vuex";

  export default {
    name: "LoginForm",
    data() {
      return {
        isAutoLogin: false,
        rules: {
          account: [
            {required: true, message: '请输入账号', trigger: 'change'},
          ],
          password: [
            {required: true, message: '请输入密码', trigger: 'change'},
          ],
        }
      };
    },
    watch: {
      loginForm: {
        deep: true,
        handler() {
          this.setIsError(false);
        },
      },
      isAutoLogin(val) {
        localStorage.setItem('isAutoLogin', val);
      },
    },
    computed: {
      loginForm: {
        get() {
          return this.form;
        },
        set(val) {
          this.setForm(val);
        },
      },
      ...mapState({
        form: state => state.loginForm,
        isError: state => state.loginError,
      })
    },
    methods: {
      handleLogin() {
      
      },
      ...mapMutations({
        setRef: 'setLoginRef',
        setForm: 'setLoginForm',
        setIsError: 'setLoginError',
      }),
    },
    created() {
      const isAutoLogin = localStorage.getItem('isAutoLogin');
      if (isAutoLogin === 'true') {
        this.isAutoLogin = true;
        this.handleLogin();
      } else {
        this.isAutoLogin = false;
      }
    },
    mounted() {
      this.setRef(this.$refs['form']);
    },
  };
</script>

<style scoped lang="stylus">
  @import "../../../assets/css/main.styl"
  .loginform {
    position relative
  }
  .errMsg {
    position absolute
    left 130px
    color error-border-color
  }
  .el-form {
    /deep/ .is-error {
      .el-input__inner {
        background-color transparent !important
      }
    }
  }

</style>
